<template>
    <div class="m-2">
        <div class="card m-2 shadow">

            <!--cabezera-->
            <div class="card-header">

                <div class="d-flex">
                    <div class="flex-fill">
                        <StatementsSearch></StatementsSearch>
                    </div>

                    <div class="float-end">
                        <StatementsPagination></StatementsPagination>
                    </div>

                </div>

            </div>

            <!--cuerpo-->
            <div class="card-body">
                <StatementsTable></StatementsTable>
            </div>
        </div>
    </div>
</template>
<script>
import StatementsTable from '@/components/Statements/StatementsList/Statements-table.vue'
import StatementsPagination from './StatementsList/Statements-pagination.vue';
import StatementsSearch from './StatementsList/Statements-search.vue';

export default {
    name: 'StatementsList',

    components:{
        StatementsTable,
        StatementsPagination,
        StatementsSearch
    }
}
</script>
<style></style>